<div class="lc-ticket-templates">
  <div class="lc-ticket-templates__head">
    <h4 class="mb-1">Templates de ticket</h4>
    <p class="text-muted small mb-0">
      Trois modèles fixes (vente, réservation, financier). Glissez les champs pour composer l'impression caisse.
    </p>
  </div>
  <div class="row mt-2">
    <div class="col-lg-4">
      <div class="table-responsive lc-table-scroll">
        <table class="table table-hover pos-ticket-table mb-0">
          <thead>
            <tr class="custom-header"><th>Type</th><th style="width:100px">Largeur</th><th style="width:90px">Statut</th></tr>
          </thead>
          <tbody>
            <tr *ngIf="loading" class="lc-loading-row"><td colspan="3"><span class="spinner-border spinner-border-sm mr-1"></span> Chargement…</td></tr>
            <tr *ngFor="let row of rows" [class.table-active]="selected?.code === row.code" class="lc-clickable-row" (click)="selectRow(row)">
              <td><strong>{{ row.libelle }}</strong><div class="small text-muted">{{ row.code }}</div></td>
              <td>{{ row.largeur_mm }} mm</td>
              <td><span class="badge" [class.badge-light-secondary]="row.is_default" [class.badge-light-success]="!row.is_default">{{ row.is_default ? 'Défaut' : 'Personnalisé' }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="small text-muted mt-2 mb-0">Ajout de nouveaux types désactivé (catalogue fixe en base).</p>
    </div>
    <div class="col-lg-8" *ngIf="selected && editLayout as layout">
      <div class="lc-ticket-editor card border">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">{{ selected.libelle }}</h5>
            <select class="custom-select custom-select-sm" style="width:90px" [value]="layout.largeur_mm" (change)="onLargeurChange($any($event.target).value)">
              <option [value]="58">58 mm</option><option [value]="80">80 mm</option><option [value]="112">112 mm</option>
            </select>
          </div>
          <div class="row">
            <div class="col-md-4">
              <p class="small font-weight-bold mb-1">Champs disponibles</p>
              <div class="lc-palette">
                <button type="button" class="btn btn-sm btn-outline-primary btn-block text-left mb-50" *ngFor="let item of palette" (click)="addFromPalette(item)">+ {{ item.label }}</button>
              </div>
            </div>
            <div class="col-md-4">
              <p class="small font-weight-bold mb-1">Composition (glisser-déposer)</p>
              <div class="lc-blocks-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
                <div class="lc-block-item" *ngFor="let block of sortedBlocks" cdkDrag>
                  <span class="lc-drag-handle" cdkDragHandle>⋮⋮</span>
                  <label class="mb-0 flex-grow-1"><input type="checkbox" [checked]="block.visible" (change)="toggleVisible(block)" /> {{ block.label }}</label>
                  <button type="button" class="btn btn-link btn-sm text-danger p-0" (click)="removeBlock(block)">×</button>
                  <input *ngIf="block.kind === 'custom'" type="text" class="form-control form-control-sm mt-50" [(ngModel)]="block.value" placeholder="Texte affiché" />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <p class="small font-weight-bold mb-1">Aperçu ticket</p>
              <div class="lc-ticket-preview" [style.maxWidth.px]="layout.largeur_mm * 3">
                <div *ngFor="let block of sortedBlocks" [hidden]="!block.visible" class="lc-preview-line" [class.lc-preview-sep]="block.kind === 'separator'">{{ previewLine(block) }}</div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center mt-2 lc-ticket-actions">
            <button type="button" class="btn btn-outline-secondary mr-1" [disabled]="!editLayout" (click)="testTicket(testTicketModal)">Test ticket</button>
            <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-50"></span>Enregistrer le modèle
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #testTicketModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Test ticket — {{ selected?.libelle }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body lc-test-ticket-modal-body">
    <p class="small text-muted mb-1">Données de démonstration — aperçu du modèle en cours.</p>
    <div class="lc-test-ticket-wrap" *ngIf="testPreviewSafe" [innerHTML]="testPreviewSafe"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Fermer</button>
    <button type="button" class="btn btn-primary" (click)="printTestTicket()">Imprimer</button>
  </div>
</ng-template>